// The price series' candle colours (DWLF-313): down candles in the scheme's red. The up colour stays
// the chart's default green. `scheme` is useSchemeColors()'s resolved palette (SVG fills can't read var()).
export const candleStyle = (scheme) => ({ downColor: scheme.down });
